import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';

import {IGetJasperReportInfoData, getJasperReportInfo, getJasperReportUrl} from './jasper-report-slice-api';
import {JASPER_REPORT_SLICE} from './jasper-report-slice-constants';

export interface ILoadJasperReportInfoArgs {
    docId?: string;
    entityName: string;
}

export const loadJasperReportInfo = createAsyncThunk<AxiosResponse<IGetJasperReportInfoData>, ILoadJasperReportInfoArgs>(
    `${JASPER_REPORT_SLICE}/loadJasperReportInfo`,
    async (args, {rejectWithValue}) => {
        try {
            const {
                docId,
                entityName,
            } = args;

            const reportUrl = docId ? `/report/?docId=${docId}` : (await getJasperReportUrl(entityName)).data as string;
            const response = await getJasperReportInfo(reportUrl);

            return response;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
